<template>
  <section class="wrapper z-10" id="section-6">
    <div class="flex flex-col gap-12 p-3 pt-12 lg:p-16">
      <div class="flex flex-col gap-4">
        <div class="flex flex-col font-inter font-bold text-[32px] text-center leading-tight">
          <span class="mb-8 lg:mb-0">Start your journey with STIMA</span>
          <span>Experience seamless asset management</span>
          <span>and unlock the Value Standard.</span>
        </div>
        <div class="flex flex-col text-center">
          <span class="text-[16px] lg:text-[20px]">Join thousands of investors who trust STIMA </span>
          <span class="text-[16px] lg:text-[20px]">for their digital asset management needs.</span>
        </div>
      </div>

      <div class="flex gap-4 flex-col lg:flex-row">
        <div class="card-hover card-hover--primary">
          <span>Start Free Trial</span>
        </div>

        <div class="card-hover card-hover--secondary">
          <span>
            <router-link to="/choose-tariff-plan">Check Pricing</router-link>
          </span>
        </div>
      </div>

    </div>
  </section>
</template>
